import { motion } from 'framer-motion'

/** Fades + rises a section into view once, on scroll. */
export default function SectionWrapper({ as = 'section', className = '', children, ...rest }) {
  const Component = motion.create(as)
  return (
    <Component
      className={className}
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-10% 0px' }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      {...rest}
    >
      {children}
    </Component>
  )
}
